import { combineReducers } from "@reduxjs/toolkit";
import songsReducer, {
  selectors as songsSelectors,
} from "state/slices/songsSlice";
import userReducer, {
  selectors as userSelectors,
} from "state/slices/userSlice";

const reducer = combineReducers({
  songs: songsReducer,
  user: userReducer,
});

export type RootState = ReturnType<typeof reducer>;

export const rootSelectors = {
  songs: songsSelectors,
  user: userSelectors,
};

export default reducer;
